import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { MarketdateBooth } from './marketdate-booth.model';
import { MarketdateBoothService } from './marketdate-booth.service';

@Component({
    selector: 'jhi-marketdate-booth-detail',
    templateUrl: './marketdate-booth-detail.component.html'
})
export class MarketdateBoothDetailComponent implements OnInit, OnDestroy {

    marketdateBooth: MarketdateBooth;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private marketdateBoothService: MarketdateBoothService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['marketdateBooth', 'contractType', 'energyPriceType', 'marketdateBoothStatus']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInMarketdateBooths();
    }

    load(id) {
        this.marketdateBoothService.find(id).subscribe((marketdateBooth) => {
            this.marketdateBooth = marketdateBooth;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInMarketdateBooths() {
        this.eventSubscriber = this.eventManager.subscribe('marketdateBoothListModification', (response) => this.load(this.marketdateBooth.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-booth/marketdate-booth-detail.component.ts